import {Check} from "@mui/icons-material";
import {Checkbox, Grid, Icon} from "@mui/material";

interface SelectOptionProps<T> {
    option: T;
    label: string;
    checked: boolean;
    renderOptionComponent?: (option: T, label: string) => React.ReactElement;
}

export function SelectOption<T>(props: Readonly<SelectOptionProps<T>>) {
    const {option, label, checked, renderOptionComponent} = props;
    return (
            <Grid container spacing={1} alignItems={"center"}>
                <Grid item xs={"auto"}>
                    <Checkbox
                            icon={<Icon fontSize="small"/>}
                            checkedIcon={<Check color="primary" fontSize="small"/>}
                            sx={{marginLeft: 0.5}}
                            checked={checked} />
                </Grid>
                <Grid item xs>
                    {renderOptionComponent ? renderOptionComponent(option, label) : label}
                </Grid>
            </Grid>
    );
}